import React from "react";
// import waiting from '../assets/images/icons8-animal-96.png'
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { loadUserAction } from "../redux/actions/userAction";
import { Link } from "react-router-dom";
import { FaPlay } from "react-icons/fa";
const MyCourses = () => {
  const { user } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(loadUserAction);
  }, [user, dispatch]);
  let playlist;
  if (user) {
    playlist = user.playlist;
  }

  return (
    <div className="bg-brand_nero flex flex-col justify-center items-center h-full py-24 my-auto text-white  w-full">
      <div className="bg-brand_jaguar h-full mx-8 lg:mx-0 lg:px-24 my-8 flex flex-col  lg:w-[800px]">
        {/* <img src={waiting} alt="" /> */}
        <h1 className="text-2xl my-3 mx-3 text-[#F37E98]">
          All your favorite courses at one place!
        </h1>
        {playlist && playlist.length > 0 ? (
          <div>
            {playlist.map((p) => (
              <div className="my-6" key={p._id}>
                <div className="lg:flex lg:my-12 lg:justify-start">
                <div className="lg:w-[250px] px-2">
                    <img
                      className="lg:h-[150px] rounded-md"
                      src={p.poster}
                      alt=""
                    />
                  </div>
                  <div className="mx-3 flex-col">
                    <h1 className="text-xl uppercase">{p?.title}</h1>
                    <Link to={`/course/${p.course}`}>
                      <button className=" text-black text-sm flex my-4 items-center gap-3 font-bold rounded-md hover:font-bold transition hover:-translate-y-1 py-2 px-6 bg-brand_yellow">
                        Play <FaPlay />
                      </button>
                    </Link>
                  </div>
                 
                </div>
              </div>
            ))}
          </div>
        ) : (
          <h1>No Courses</h1>
        )}
      </div>
    </div>
  );
};

export default MyCourses;
